"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.maybeUpdatePrintableDependsOnLayers = exports.layersHaveDependsOn = exports.printableHasDependsOnLayersToUpdate = exports.getNeedsDependsOnUpdate = void 0;
const Product_1 = require("../../../models/Product");
const strings_1 = require("../../../helpers/strings");
const layers_1 = require("../../../helpers/HAMMER/layers");
const template_1 = require("../../template");
const either_1 = require("../../../types/either");
const getNeedsDependsOnUpdate = (art, project, cleanOptions) => {
  if (art.category !== Product_1.HAMMER_CATEGORY_CARDS && art.category !== Product_1.HAMMER_CATEGORY_FOLDED_CARDS) {
    return (0, either_1.right)(false);
  }
  const cleanOptionKeys = Object.keys(cleanOptions);
  const {
    printableGroups
  } = project;
  const projectHasDependsOn = printableGroups.some(printableGroup => {
    return printableGroup.printables.some((0, exports.printableHasDependsOnLayersToUpdate)(cleanOptionKeys));
  });
  const selectNewTemplateResult = (0, template_1.selectTemplate)(cleanOptions, art);
  if (selectNewTemplateResult.isLeft()) {
    return (0, either_1.left)(selectNewTemplateResult.value);
  }
  const newTemplateHasDependsOn = (0, exports.layersHaveDependsOn)(selectNewTemplateResult.value.template.layers, cleanOptionKeys);
  return (0, either_1.right)(projectHasDependsOn || newTemplateHasDependsOn);
};
exports.getNeedsDependsOnUpdate = getNeedsDependsOnUpdate;
const printableHasDependsOnLayersToUpdate = cleanOptionKeys => printable => {
  return (0, exports.layersHaveDependsOn)(printable.layers, cleanOptionKeys);
};
exports.printableHasDependsOnLayersToUpdate = printableHasDependsOnLayersToUpdate;
const layersHaveDependsOn = (layers, cleanOptionKeys) => {
  return layers.some(layer => {
    var _a;
    return (_a = layer.dependsOn) === null || _a === void 0 ? void 0 : _a.some(dependsOn => {
      const dependsOnOption = (0, strings_1.getAfterSubstring)(dependsOn.value, 'art.attributes.').split(':')[0];
      return cleanOptionKeys.includes(dependsOnOption);
    });
  });
};
exports.layersHaveDependsOn = layersHaveDependsOn;
const maybeUpdatePrintableDependsOnLayers = (printable, cleanOptions, artAttributes) => {
  if (!(0, exports.printableHasDependsOnLayersToUpdate)(Object.keys(cleanOptions))(printable)) {
    return printable;
  }
  return Object.assign(Object.assign({}, printable), {
    layers: (0, layers_1.resolveDependsOnValuesForLayers)(printable.layers, artAttributes, cleanOptions)
  });
};
exports.maybeUpdatePrintableDependsOnLayers = maybeUpdatePrintableDependsOnLayers;